import { render, staticRenderFns } from "./superedit.vue?vue&type=template&id=33043935&"
import script from "./superedit.vue?vue&type=script&lang=js&"
export * from "./superedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports